function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 21.221,
  cy: 21.221,
  r: 21.221,
  transform: "translate(0)",
  fill: "#2aa3ef"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Twitter-2",
  "data-name": "Twitter",
  d: "M17.412,1.675a7.166,7.166,0,0,1-2.052.563A3.583,3.583,0,0,0,16.93.262a7.139,7.139,0,0,1-2.269.866,3.574,3.574,0,0,0-6.18,2.444,3.612,3.612,0,0,0,.093.815A10.14,10.14,0,0,1,1.213.654,3.575,3.575,0,0,0,2.318,5.422,3.543,3.543,0,0,1,.7,4.975v.045a3.573,3.573,0,0,0,2.865,3.5,3.567,3.567,0,0,1-.941.125,3.514,3.514,0,0,1-.672-.065A3.578,3.578,0,0,0,5.29,11.064,7.177,7.177,0,0,1,.852,12.592,7.2,7.2,0,0,1,0,12.542a10.109,10.109,0,0,0,5.476,1.6A10.093,10.093,0,0,0,15.64,3.986c0-.156,0-.308-.01-.462a7.26,7.26,0,0,0,1.782-1.848Z",
  transform: "translate(12.515 14.147)",
  fill: "#fff"
});

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Twitter",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.441,
    height: 42.441,
    viewBox: "0 0 42.441 42.441",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.8f8fdd11.svg";
export { ForwardRef as ReactComponent };